import * as React from "react";
import { Link } from "gatsby";

import Layout from "../../components/Layout";
import Seo from "../../components/Seo";

import Old2005BlogPage from "../../components/Old2005BlogPage";

const OldBlogPage = () => (
  <Layout>
    <Seo title="Old 2005 Blog—September 2006" />
	<Old2005BlogPage>
		<h2>September 2006</h2>




		<h3 className="blogdate">
		Tuesday, September 19, 2006
		</h3>






		<h4 className="blogitemtitle">
		More words from Victoria
		</h4>





			<div className="blogitembody">
			This past weekend was wonderfully crazy!  I performed on stage after Bill Henderson, of Chilliwack (and other musical endeavors) fame, and then Valdy picked me up when I was hitch-hiking from Ganges to Fulford Harbour on Salt Spring Island!<br /><br />Well, what's happened since my last words from Victoria?  Yes, by the way, I am at Stain again, a great internet cafe.   I spent some time in Nanaimo, in the great comfort of Trish's home, near the ocean, where I relaxed and practiced my music, jammed with Bobby, and shared great meals.  Bobby and Trish are great people, and I am very grateful to Trish for the opportunity, conversations, accomodation and hospitality!<br /><br />On Friday I went to Salt Spring and met Billie Woods at Moby's Marine Pub.  I opened the evening's music with a 45 minute, then Billie joined forces with some great musicians - Bob, Darcey, and Fidel - to produce a fine evening of dancingly great music!  It's a great pub and I hope to return.<br /><br />The next day I hung out at a cool market in Ganges, then went to the Fall Fair on Rainbow road.  I'm pretty sure I passed Tom Hooper and his kids on the way in.  I could hear music as I made my way in to the stage and beer garden area, and as I neared I realized that Bill Henderson was playing.  I also then realized that I was on stage next!  I have a lot of respect for Bill Henderson, but rather than shit my pants I just sucked it up and blasted off a few songs to the crowd.  It was fun!  Billie and the boys shut the evening down with some more great music.  I am VERY grateful to Billie for inviting me to the island twice this September, and I am grateful to Nellie (Nelly?  oops I forget) for slotting me into the Fall Fair.  <em>Seriously.... thanks Billie!!!!</em><br /><br />That night I learned to play a very cool dice game, then I went to the After Fair Affair party for a bit of slide blues dancing tunes.  I don't even know who was playing but it was fun.  The next day was rainy but I stuck it out at the fair grounds and caught Valdy performing, followed by Drop Radio.   The rain stopped midway and both performances were great!  I think Drop Radio has a website coming soon, probably called dropradio.com.  You should check them out, especially if you like reggae style!<br /><br />I was hitch-hiking from Ganges to Fulford Harbour and Valdy picked me up.  What a nice man!  We talked a bit about touring New Zealand, and about life on Salt Spring Island, before he recommended the squash and bean stew at Tree House South and then dropped me off.  I went in to Tree House South, they were out of Valdy's recommended chow, but the lentil soup was wicked good.<br /><br />The ferry-ride back to Schwartz Bay was mystic in the dark.  Islands were but silhouettes, some with randomly lit homes.  You could see the direction of Victoria as it's lights illuminated the misty-clouds above it.  I felt sad to leave Salt Spring Island, but that sadness was far outweighed by my happiness for having such great musical experiences there!
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 2:47 PM &nbsp;
			</div>






		<h3 className="blogdate">
		Friday, September 08, 2006
		</h3>






		<h4 className="blogitemtitle">
		Words from Victoria!
		</h4>





			<div className="blogitembody">
			I'm in an internet cafe in Victoria called Stain.  I don't get it, either, but the computers are super fast.  I'm going to try and be brief, but many cool things have happened since Kelowna!  Kelowna was great - I spent lots of time with family, enjoyed a trip to Naramata, rediscovered the magic of Shorts Creek with Lynn and Ryan, and found a secret beach, which Lynn calls Baja Beach. You'll never find it, don't even try.  Also, mom and I discovered The Dream Cafe in Penticton, it rocks, you should check it out!  I should also mention that my Kelowna shows were great fun, thanks to everyone who came!<br /><br />My Victoria shows were, hmmm, how shall I say this?  "Under par" seems fitting.  However, let's focus on the positive!  I made some new friends and fans at Spiral Cafe, thanks to everyone who was there!  I met Jenny Ritter at Solstice Cafe, and later I watched her band The Gruf perform... they are super-great!  You should check them out, see Myspace.  I'm in a hurry so I'm not going to provide links like I usually do.<br /><br />BIG thanks to Dori and Fishie for helping me with my shows in Vic, and for accomodating me, showing me Victoria, being supportive, and being generally quirky late at night when I'm fading fast!  Biggest thanks to you two!<br /><br />When I was in Kelowna, I met Billie Woods after her performance with Three Times a Lady.  Billie invited me to Salt Spring Island on September 3, and I joined her for a performance at Tree House Cafe in Ganges.  This was wicked fun!  The musical evening included performances from Sharon Baily, myself and Billie, and Laughlin Meagher of Drop Radio.  I danced it up large to the Drop Radio tunes - very cool acoustic reggae style, great lyrics!  I feel very fortunate for meeting Billie and being apart of Tree House's last musical evening of the season.  Salt Spring Island is beautiful, and there are deer everywhere, almost as abundant as roos in Margaret River (or anywhere, really), Australia!<br /><br />Here's a few fun things to do in Victoria.  Go to Starfish Glassworks and watch the masters blow glass and create spectacular glass things.  Go see The Gruf play at Spinnaker's pub, or wherever they may be playing.  Go down to the harbour and hang with the buskers.  Take a ferry to an island for the day!<br /><br />Okay, I'm out!
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 9:51 AM &nbsp;
			</div>





		<p>
			<Link to="/blog2005/">Go back to the blog index page</Link>
		</p>
</Old2005BlogPage>
  </Layout>
)

export default OldBlogPage;
